import React from 'react';
import { RuterStoppsImage } from './RuterStoppsImage';
import { Divider } from '@ruter-ds/rds-components/dist/cjs';

import config from '../config';

export const QuestionDescription = ({ question }) => {
    return (
        <div>
            {question.picture && (
                <RuterStoppsImage
                    objectFit="contain"
                    style={{ maxWidth: 200, maxHeight: 200 }}
                    className="questionTypeImage"
                    alt={question.description}
                    src={`${config.serverUrl}document/download/lowRes/${question.picture?.filepath}`}
                />
            )}
            {question.description && <p className="rds-my--s">{question.description}</p>}
            <Divider spacing="s" />
        </div>
    );
};
